import React, { useState } from "react";
import { cadastrarServico } from "../../api/apiService";
import Navbar from "../../components/Navbar";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  Switch,
  FormControl,
  InputLabel,
  FormControlLabel,
  Typography,
  Alert,
  CircularProgress,
  Checkbox,
} from "@mui/material";

const CadastrarServico = () => {
  const [nome, setNome] = useState("");
  const [cidade, setCidade] = useState("Recife");
  const [categoria, setCategoria] = useState("CONSULTA");
  const [requerImagem, setRequerImagem] = useState(false);
  const [habilitarCidades, setHabilitarCidades] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const cidadesVizinhas = [
    "Recife",
    "Olinda",
    "Jaboatão dos Guararapes",
    "Paulista",
    "Igarassu",
    "Abreu e Lima",
    "Cabo de Santo Agostinho",
    "Carpina",
    "Timbaúba",
    "Vicência",
    "Limoeiro",
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);

      // Definir nome final do serviço com ou sem cidade
      const nomeCompleto = habilitarCidades ? `${nome} - ${cidade}` : nome;

      await cadastrarServico({ nome: nomeCompleto, categoria, requerImagem });
      setMensagem("Serviço cadastrado com sucesso!");
      setIsError(false);
      setNome(""); // Limpa apenas o nome
    } catch (error) {
      setMensagem("Erro ao cadastrar serviço. Tente novamente.");
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        bgcolor: "#f5f5f5",
        minHeight: "100vh",
        p: 4,
        marginTop: "7vh",
        "@media (max-width: 720px)": {
          marginTop: "5vh",
          p: 2,
        },
      }}
    >
      <Box
        sx={{
          bgcolor: "#fff",
          borderRadius: 2,
          p: 4,
          boxShadow: 3,
          maxWidth: "900px",
          mx: "auto",
          "@media (max-width: 720px)": {
            p: 3,
          },
        }}
      >
        <Navbar />
        <Typography variant="h5" gutterBottom>
          Cadastrar Serviço
        </Typography>

        {mensagem && (
          <Alert severity={isError ? "error" : "success"} sx={{ mb: 2 }}>
            {mensagem}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              alignItems: "center",
              mb: 3,
              "@media (max-width: 600px)": {
                flexDirection: "column",
              },
            }}
          >
            {/* Nome do Serviço */}
            <TextField
              label="Nome do Serviço"
              variant="outlined"
              fullWidth
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              required
              sx={{ flex: 1 }}
            />

            {/* Checkbox para habilitar a seleção de cidades */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={habilitarCidades}
                  onChange={() => setHabilitarCidades((prev) => !prev)}
                  color="primary"
                />
              }
              label="Cidade?"
            />

            {/* Cidade - Só fica habilitada se o checkbox estiver marcado */}
            <FormControl fullWidth sx={{ flex: 1 }}>
              <InputLabel id="cidade-label">Cidade</InputLabel>
              <Select
                labelId="cidade-label"
                value={cidade}
                onChange={(e) => setCidade(e.target.value)}
                required
                disabled={!habilitarCidades} // Desativa o campo se o checkbox estiver desmarcado
              >
                {cidadesVizinhas.map((cidade) => (
                  <MenuItem key={cidade} value={cidade}>
                    {cidade}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            {/* Categoria */}
            <FormControl fullWidth>
              <InputLabel id="categoria-label">Categoria</InputLabel>
              <Select
                labelId="categoria-label"
                value={categoria}
                onChange={(e) => setCategoria(e.target.value)}
                required
              >
                <MenuItem value="CONSULTA">CONSULTA</MenuItem>
                <MenuItem value="EXAME">EXAME</MenuItem>
                <MenuItem value="TRANSPORTE">TRANSPORTE</MenuItem>
              </Select>
            </FormControl>

            {/* Requer Imagem */}
            <FormControlLabel
              control={
                <Switch
                  checked={requerImagem}
                  onChange={() => setRequerImagem((prev) => !prev)}
                  color="primary"
                />
              }
              label="Requer Imagem"
            />

            {/* Botão Cadastrar com indicador de carregamento */}
            <Button
              variant="contained"
              color="primary"
              type="submit"
              fullWidth
              sx={{ mt: 2 }}
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress size={24} style={{ color: "white" }} />
              ) : (
                "Cadastrar"
              )}
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default CadastrarServico;
